"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _image = _interopRequireDefault(require("next/image"));

var _Sizer = _interopRequireDefault(require("@components/Picture/components/Sizer"));

var _scss = require("@scss");

var _excluded = ["classes", "component", "image", "layout", "alt", "onLoad", "height", "width", "style"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Unify layout, visit https://nextjs.org/docs/api-reference/next/image#layout for more information
var NEXT_LAYOUT = {
  fixed: 'fixed',
  full: 'fill',
  fluid: 'intrinsic',
  background: 'fill'
};

var NextPicture = function NextPicture(_ref) {
  var _NEXT_LAYOUT;

  var classes = _ref.classes,
      _ref$component = _ref.component,
      Wrapper = _ref$component === void 0 ? 'div' : _ref$component,
      image = _ref.image,
      layout = _ref.layout,
      alt = _ref.alt,
      onLoad = _ref.onLoad,
      height = _ref.height,
      width = _ref.width,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, _excluded);

  var thisImage = (0, _react.useMemo)(function () {
    if (typeof image === 'string') {
      return image;
    }

    if (_typeof(image) === 'object') {
      if (image !== null && image !== void 0 && image.file) {
        return image.file;
      }

      return image;
    }

    return null;
  }, [image]);

  var _useState = (0, _react.useState)({
    height: height,
    width: width
  }),
      _useState2 = _slicedToArray(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1];

  var thisLayout = (_NEXT_LAYOUT = NEXT_LAYOUT === null || NEXT_LAYOUT === void 0 ? void 0 : NEXT_LAYOUT[layout]) !== null && _NEXT_LAYOUT !== void 0 ? _NEXT_LAYOUT : 'intrinsic';

  var wrapperStyle = _objectSpread(_objectSpread(_objectSpread({}, layout === 'background' && {
    position: 'absolute',
    inset: 0
  }), layout === 'full' && {
    position: 'relative'
  }), style);

  var imageProps = _objectSpread(_objectSpread({
    onLoad: typeof onLoad === 'function' || thisLayout === 'fill' ? function (e) {
      if (thisLayout === 'fill') {
        var _ref2, _ref3;

        var img = e === null || e === void 0 ? void 0 : e.target;
        var size = {
          height: (_ref2 = height !== null && height !== void 0 ? height : img === null || img === void 0 ? void 0 : img.naturalHeight) !== null && _ref2 !== void 0 ? _ref2 : 100,
          width: (_ref3 = width !== null && width !== void 0 ? width : img === null || img === void 0 ? void 0 : img.naturalWidth) !== null && _ref3 !== void 0 ? _ref3 : 100
        };
        setDimensions(size);
      }

      typeof onLoad === 'function' && onLoad(e);
    } : undefined
  }, (layout === 'fixed' || layout === 'fluid') && dimensions), props);

  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    "data-picture-wrapper": true,
    className: (0, _scss.cls)(classes === null || classes === void 0 ? void 0 : classes.wrapper),
    style: wrapperStyle
  }, dimensions && /*#__PURE__*/_react["default"].createElement(_Sizer["default"], {
    layout: layout,
    height: Number(dimensions.height),
    width: Number(dimensions.width)
  }), /*#__PURE__*/_react["default"].createElement(_image["default"], _extends({
    src: thisImage,
    layout: thisLayout,
    alt: alt,
    className: classes === null || classes === void 0 ? void 0 : classes.picture
  }, !!(thisImage !== null && thisImage !== void 0 && thisImage.base64) && {
    placeholder: 'blur',
    blurDataURL: thisImage.base64
  }, {
    quality: 100
  }, imageProps)));
};

var _default = NextPicture;
exports["default"] = _default;